/* tslint:disable */
/* eslint-disable */

export interface AbsenceInfoTO {
    absence: string;
    altRepresentative: string;
    comment: string;
    from: number;
    representative: string;
    to: number;
}

export interface AppEventParamTO {
    key: string;
    value: string;
}

export interface AppEventTO {
    eventname: string;
    hook: string;
    id: number;
    params: AppEventParamTO[];
    prio: number;
}

export interface AttachmentTO extends Serializable {
    data: string;
    dstField: string;
    filename?: string;
    lat?: number;
    lazy?: boolean;
    lon?: number;
    mimeType?: string;
    persist?: boolean;
    pos: number;
    preview?: string;
    version?: number;
}

export interface AuftTO {
    auftkey: string;
    aufttext: string;
    gueltigBis: number;
    gueltigVon: number;
    kostkey: string;
    sollSt: number;
    status: string;
}

export interface AzeBookingErrorTO {
    bookingError: { [index: string]: string };
    bookingNr: number;
    koWertError: { [index: string]: string };
}

export interface AzeBookingTO {
    azeBookingErrorTo: AzeBookingErrorTO;
    bewEinh: string;
    bookingDate: number;
    bookingNr: number;
    bookingTime: number;
    bookingTimespan: number;
    bookingType: string;
    dev: string;
    edit: boolean;
    einstuf: number;
    empfEinh: string;
    hourCategory: string;
    koWertList: KoWertTO[];
    loeschKz: string;
    persNr: number;
    text: string;
    user: string;
}

export interface BookingTO {
    bewEinh: string;
    bookingDate: number;
    bookingNr: number;
    bookingTime: number;
    bookingTimespan: number;
    bookingType: string;
    cf: AttachmentTO[];
    dev: string;
    einstuf: number;
    einstufArt: string;
    empfArt: string;
    empfEinh: string;
    gruppeKz: string;
    hourCategory: string;
    loeschKz: string;
    persNr: number;
    sisName: string;
    stKey: string;
    stTagKey: string;
    stornos?: StornoTO[];
    text: string;
    user: string;
}

export interface BuchungTO {
    benutzer: string;
    bewEinh: string;
    buart: string;
    buchdat: number;
    buchzeit: number;
    buchzsp: number;
    butext: string;
    datum: number;
    dev: string;
    einstuf: number;
    einstufArt: string;
    empfArt: string;
    empfEinh: string;
    gruppeKz: string;
    id: number;
    kartnr: number;
    kbuchnr: number;
    leistArt: string;
    leistEinh: number;
    loeschKz: boolean;
    stTagkey: string;
    stkey: string;
    stuart: string;
    sysdat: number;
    syszeit: number;
    verrKz: string;
}

export interface CFAttrTO {
    cfdef: number;
    id: number;
    key: string;
    type: string;
    value: string;
}

export interface CFValiTO {
    cacheTTL: string;
    dqParams: DqParamTO[];
    id: number;
}

export interface CfGroupTO extends Serializable {
    heading: string;
    id: number;
    mergeAmountButtons: boolean;
}

export interface ClientColumnTO {
    cell: string;
    columnProps: { [index: string]: any };
    editable: boolean;
    filterMethod: ColumnFilterMethod;
    filterable: boolean;
    label: string;
    name: string;
    renderable: boolean;
    sortable: boolean;
}

export interface ColorPairTO {
    bgColor?: string;
    textColor?: string;
}

export interface CompoundPropertyTO {
    attribute: string;
    compositeId: string;
    object: string;
    subkrit: string;
    type: PropType;
    value: string;
}

export interface CostCenterTO2 {
    costId: string;
    costText: string;
    kostMM: { [index: string]: string };
    sortIndex: number;
    validFrom: number;
    validTill: number;
}

export interface CustomFieldTO {
    cfAttrs: CFAttrTO[];
    cfGroupId?: number | null;
    cfValiIds: number[];
    colSpan?: number | null;
    defaultValue?: string | null;
    dqKey: string;
    dqParams: DqParamTO[];
    dstField: string;
    forceDq: boolean;
    funcOnInsert?: string | null;
    hpos: number;
    id: number;
    input: string;
    insertable: boolean;
    label: string;
    length: number;
    maxAmount: number;
    minAmount: number;
    mtab: string | null;
    mustMatchDq: boolean;
    nullValue?: string | null;
    pinned: boolean;
    primaryKey: boolean;
    required: boolean;
    rowSpan?: number | null;
    searchable: boolean;
    sortable: boolean;
    startIndex: number;
    type: SisType;
    updatable: boolean;
    visible: boolean;
    vpos: number;
    zpos: number;
}

export interface DayInfoIstTO {
    compositeId: string;
    date: number;
    ist: number;
    persNr: number;
}

export interface DayInfoSollTO {
    compositeId: string;
    date: number;
    persNr: number;
    sisName: string;
    soll: number;
}

export interface DayInfoTO {
    className: string;
    compositeId: string;
    date: number;
    ist: number;
    persNr: number;
    sisName: string;
    soll: number;
}

export interface DqButtonTO {
    dqKey: string;
    icon?: string;
    id: number;
    label?: string;
    location: string;
    position: number;
    tooltip?: string;
}

export interface DqParamTO {
    defaultValue: string | null;
    dstName: string;
    id?: number;
    length?: number;
    srcName: string;
    startIndex: number;
    type: string;
}

export interface DqRequestTO {
    filter?: string;
    id: string;
    isAze?: boolean;
    params?: { [index: string]: any };
}

export interface DqResponseTO {
    cacheTTL: string;
    count: number;
    elements: { [index: string]: any }[];
    id: string;
    label: string;
    searchable: boolean;
}

export interface EFileCatTO {
    cfDef: CustomFieldTO | null;
    color: ColorPairTO;
    entity: EFileEntity;
    id: number;
    name: string;
    nr: number | null;
    perm: PermissionTO;
}

export interface EFileCreateRequestTO {
    efile: EFileTO;
    entityID: EntityIdTO;
}

export interface EFileTO {
    category: number;
    data?: string;
    filename: string;
    id: number;
    mimeType: string;
    nr: number;
}

export interface EntityIdTO {
    auftkey?: string | null;
    entity: EFileEntity;
    kostkey?: string | null;
    persNr?: number | null;
    taskId?: number | null;
}

export interface EntryDescInitTO {
    entryDescId: number;
    kost?: string;
    onlyOne?: boolean;
}

export interface EntryDescTO extends RulesetTO {
    bookingType: string;
    bookingTypeText: string;
    hourCategory: string;
    hourCategoryText: string;
    id: number;
    perm?: PermissionTO | null;
    rulesetSelfAdmin?: RulesetTO | null;
    sortKey: number;
    terminalColor: ColorPairTO;
    typeCategoryColor: ColorPairTO;
    typeColor: ColorPairTO;
    typeGroupId?: number | null;
}

export interface EventContainerTO {
    eventParams: EventParamTO[];
    events: EventTO[];
}

export interface EventParamTO {
    key: string;
    parentId: number;
    value: string;
}

export interface EventTO {
    eventname: string;
    hook: string;
    id: number;
    prio: number;
}

export interface EvoAppsUserInfoTO {
    calculation: PersonCalculationInfoTO;
    className: string;
    costCenter: PersonCostCenterInfoTO;
    evoAppsUser: EvoAppsUserWrapperTO;
    ewsRepList: EwsRepTO[];
    mailVertretungRendered: boolean;
    passwordPanelRendered: boolean;
    personalInfo: PersonalInfoTO;
    useTmsKw: boolean;
    vorgztUserRendered: boolean;
}

export interface EvoAppsUserTO {
    className: string;
    email: string;
    longUsername: string;
    persNr: number;
    text: string;
    userGroup: MenugrpTO;
    username: string;
}

export interface EvoAppsUserWrapperTO {
    alternativeMandants: MandantTO[];
    alternativeUser: boolean;
    alternativeUsers: EvoAppsUserTO[];
    className: string;
    defaultEvoAppsUser: EvoAppsUserTO;
    defaultMandant: MandantTO;
    email: string;
    longUsername: string;
    mandant: MandantTO;
    nativeLoggedIn: boolean;
    persNr: number;
    text: string;
    userGroup: MenugrpTO;
    username: string;
    vorgesetzterUser: VorgztUserTO;
}

export interface EvoMenuParamTO {
    evomenu: number;
    id: number;
    key: string;
    type: string;
    value: string;
}

export interface EvoMenuTO {
    icon: string;
    id: number;
    label: string;
    menu_gid: string;
    modul: string;
    modulTyp: ModuleType;
    nr: number;
    pageUrl: string;
    params: EvoMenuParamTO[];
    parent: number;
}

export interface EwsRepTO {
    displayName: string;
    repAddress: string;
    useFwdRule: boolean;
}

export interface FavoriteTO {
    className: string;
    ilvKuerz: string;
    koWertList: string[];
    koWertVisbaleColumns: boolean[];
    name: string;
    text: string;
}

export interface FreigabeKostRequestTO {
    date: number;
    kostkey: string;
    vorgUser: string;
}

export interface FreigabePersRequestTO {
    date: number;
    persNr: number;
}

export interface FreigabeTO {
    blocking: boolean;
    buart: string;
    color: ColorPairTO;
    date: number;
    kostkey: string;
    label: string;
    persNr: number;
    time: number;
    type: FreigabeType;
    vorgText: string;
}

export interface GetAttachmentTO {
    dstField: string;
    fetchMode: AttachmentFetchMode;
    id: number;
    pos: number;
    sisName: SisName;
}

export interface HolidayTO {
    compositeId: string;
    feierDatum: number;
    feierKey: string;
    sisName: string;
    text: string;
}

export interface ISSMaxWorkTimeTO {
    maxDaySum: number;
    maxWeekSum: number;
}

export interface KoWertTO {
    dqKey: string;
    name: string;
    nr: number;
    required: boolean;
    size: number;
    type: string;
    value: string;
    visible: boolean;
}

export interface MandantLockTO {
    bisdat: number;
    className: string;
    mandantLockDispalyText: string;
    vondat: number;
}

export interface MandantTO {
    className: string;
    id: string;
    mandantLock: MandantLockTO;
    mandantLockDispalyMessage: string;
    text: string;
}

export interface MenugrpTO {
    className: string;
    description: string;
    id: string;
    userLevel: string;
}

export interface ModelChangeBookingTO {
    bookingNr: number;
    datum: number;
    persNr: number;
    stTagkey: string;
    stkey: string;
}

export interface NotiDispatcherCFDefsTO {
    noti: CustomFieldTO[];
    receiver: CustomFieldTO[];
}

export interface NotiQueueTO {
    action?: string | null;
    actiontype?: string | null;
    bisdat: number;
    biszeit: number;
    bkey?: string | null;
    content?: string | null;
    deletable: string;
    hidden?: string | null;
    id?: number | null;
    lcts: Date;
    nr: number;
    prioritaet: number;
    read: string;
    receivers: string[];
    status: NotiStatus;
    title?: string | null;
    vondat: number;
    vonzeit: number;
}

export interface NotiTO {
    action?: string;
    actionType?: string;
    bisDat: number;
    bisZeit: number;
    bkey: string;
    content?: string;
    deletable: boolean;
    hidden?: string;
    id: number;
    nr: number;
    prio: number;
    read: boolean;
    title?: string;
    user: string;
    vonDat: number;
    vonZeit: number;
}

export interface ParamdivTO {
    app: string;
    compositeId: string;
    crit: string;
    subCrit: string;
    value: string[];
}

export interface PermissionTO {
    abl?: boolean;
    abl_s?: boolean;
    crt?: boolean;
    crt_s?: boolean;
    del?: boolean;
    del_s?: boolean;
    gen?: boolean;
    gen_s?: boolean;
    rd?: boolean;
    rd_s?: boolean;
    storno?: boolean;
    storno_s?: boolean;
    upd?: boolean;
    upd_s?: boolean;
}

export interface PersInfTO {
    code: string;
    details: string[];
    fkey: string;
    from: number;
    nr: number;
    persInfoId: number;
    persNr: number;
    to: number;
}

export interface PersNrsDateRangeTO {
    from: number;
    persNrs: number[];
    to: number;
}

export interface PersStat2TO {
    benutzer: string;
    lbuchnr: number;
    persNr: number;
    status: string;
    statusBis: number;
    vdatum: number;
    verrBis: number;
    vzeit: number;
}

export interface PersonCalculationInfoTO {
    className: string;
    clearedToDate: string;
    errorMessages: VlFehlTO[];
    panelRendered: boolean;
}

export interface PersonCostCenterInfoTO {
    baseBewEinh: string;
    className: string;
    currentBewEinh: string;
    empfEinh: string;
    panelRendered: boolean;
}

export interface PersonTO {
    angFrom: number;
    angTill: number;
    arbverh: string;
    bereich: string;
    betriebsnr: string;
    bezirk: string;
    bookingApproval: number;
    bookingApprovalTime: number;
    bookingEnd: number;
    bookingEndAze: number;
    boundaries: { [index: string]: WorkTimeModelTO };
    dayInfos: DayInfoTO[];
    ffld1: number;
    ffld2: number;
    gebOrt: string;
    gemeinde: string;
    kartNr: number;
    kfld2: string;
    land: string;
    mandantAktiv: string;
    myself: boolean;
    ort: string;
    persNr: number;
    photo: string;
    plz: string;
    religion: string;
    revier: string;
    sortIndex: number;
    taetig: string;
    verwendgr: string;
    vorname: string;
    zuname: string;
}

export interface PersonalInfoTO {
    className: string;
    infos: string[];
    panelRendered: boolean;
}

export interface PersstChangeRequestTO {
    auslandKz?: string;
    azebukz?: string;
    bewEinh?: string;
    bisdat: number;
    einstuf?: number;
    einstufArt?: string;
    empfArt?: string;
    empfEinh?: string;
    feierkey?: string;
    flsVerrkey?: string;
    kokey?: string;
    limitkey?: string;
    persNrs: number[];
    reiseSchl?: string;
    stkey?: string;
    tolera?: number;
    ueberstdBer?: string;
    vondat: number;
}

export interface PersstCopyRequestTO {
    bisdat: number;
    cpAuslandKz?: JaNeinTO;
    cpAzebukz?: JaNeinTO;
    cpBewEinh?: JaNeinTO;
    cpClearPersstTag?: JaNeinTO;
    cpEinstuf?: JaNeinTO;
    cpEinstufArt?: JaNeinTO;
    cpEmpfArt?: JaNeinTO;
    cpEmpfEinh?: JaNeinTO;
    cpFeierkey?: JaNeinTO;
    cpFlsVerrkey?: JaNeinTO;
    cpKokey?: JaNeinTO;
    cpLimitkey?: JaNeinTO;
    cpMaBooking?: JaNeinTO;
    cpPersstTag?: JaNeinTO;
    cpReiseSchl?: JaNeinTO;
    cpStkey?: JaNeinTO;
    cpTolera?: JaNeinTO;
    cpUeberstdBer?: JaNeinTO;
    persNrs: number[];
    sourcePersNr: number;
    vondat: number;
}

export interface PersstDialogCFDefTO {
    copy: CustomFieldTO[];
    persst: CustomFieldTO[];
    persstTag: CustomFieldTO[];
}

export interface PersstResultTO {
    maBookings: ModelChangeBookingTO[];
    persNr: number;
    persst: PersstTO[];
    persstTag: PersstTagTO[];
}

export interface PersstTO {
    auslandKz: string;
    azebukz: string;
    bewEinh: string;
    bisdat: number;
    einstuf: number;
    einstufArt: string;
    empfArt: string;
    empfEinh: string;
    feierkey: string;
    flsVerrkey: string;
    kokey: string;
    limitkey: string;
    persNr: number;
    reiseSchl: string;
    stkey: string;
    tolera: number;
    ueberstdBer: string;
    vondat: number;
}

export interface PersstTagChangeRequestTO {
    bisdat: number;
    persNrs: number[];
    stTagkey?: string;
    stkey?: string;
    vondat: number;
}

export interface PersstTagTO {
    datum: number;
    persNr: number;
    stTagkey: string;
    stkey: string;
}

export interface PersurlTO {
    altRepresentative: number;
    cf: AttachmentTO[];
    end: number;
    hourCategory: string;
    id: number;
    openMarking: string;
    persNr: number;
    representative: number;
    sisName: string;
    start: number;
    stornos: StornoTO[];
    text: string;
}

export interface PlanEntryTO {
    bewEinh: string;
    bookingDate: number;
    bookingTime: number;
    bookingTimespan: number;
    bookingType: string;
    empfEinh: string;
    hourCategory: string;
    id: string;
    persNr: number;
    sisName: string;
    stKey: string;
    stTagKey: string;
    text: string;
}

export interface PlanMastTO {
    aktiv: boolean;
    del: boolean;
    endDat: number;
    id: number;
    inUse: boolean;
    periods: number;
    planText: string;
    rd: boolean;
    startDat: number;
    tage: PlanTagTO[];
    upd: boolean;
}

export interface PlanPersRequestTO {
    endDat: number | null;
    persNr: number | null;
    planMast: number;
    startDat: number;
    weeksHours: number[];
}

export interface PlanPersTO {
    endDat?: number | null;
    id: number;
    persNr: number;
    planMast: number;
    planText: string;
    startDat: number;
}

export interface PlanTagTO {
    id: number;
    mpause: number;
    planMast: number;
    tagorder: number;
    tagzsp: number;
    valid: boolean;
}

export interface PlanTemplTO {
    bewEinh: string;
    bookingTime: number;
    bookingTimespan: number;
    bookingType: string;
    empfEinh: string;
    hourCategory: string;
    id: number;
    planTag: number;
    sisName: string;
    stKey: string;
    stTagKey: string;
    text: string;
}

export interface PresenceStatusTO {
    absenceInfo: AbsenceInfoTO;
    absenceInfoText: string;
    arbverh: string;
    arbverhText: string;
    assignment: string;
    assignmentText: string;
    buchnr: number;
    cardNr: number;
    clearedBy: number;
    department: string;
    departmentText: string;
    farbeText: string;
    firstName: string;
    icon: string;
    lastName: string;
    operation: string;
    operationText: string;
    persNr: number;
    persurlnr: number;
    presence: string;
    schuhgr: string;
    status: string;
    statusText: string;
    territory: string;
    territoryText: string;
}

export interface RepParamTO {
    cfdef: number;
    colSpan: number;
    hpos: number;
    id: number;
    rowSpan: number;
    s_key: string;
    vpos: number;
    zpos: number;
}

export interface ReportRequestTO {
    bcc: string[];
    cc: string[];
    params: { [index: string]: string };
    subject: string;
    title: string;
    to: string[];
}

export interface ReportResponseTO {
    bcc: CustomFieldTO;
    cc: CustomFieldTO;
    mail: string;
    tabTitle: string;
    title: string;
}

export interface RulesetTO {
    abltext?: string;
    buchzeitBisEingebbar: boolean;
    buchzeitBisInit: number;
    buchzeitBisInitAus: string;
    buchzeitBisTakt: number;
    buchzeitBisTaktA: string;
    buchzeitBisTaktAus: string;
    buchzeitVonEingebbar: boolean;
    buchzeitVonInit: number;
    buchzeitVonInitAus: string;
    buchzeitVonTakt: number;
    buchzeitVonTaktAus: string;
    buchzeitVonZwingend: boolean;
    buchzspEingebbar: boolean;
    buchzspInit: number;
    buchzspZwingend: boolean;
    butextDq: string;
    butextKostmm: string;
    butextLaenge: number;
    butextText: string;
    butextTyp: string;
    butextZwingend: boolean;
    checkMaxDuration: boolean;
    checkbox: boolean;
    customFieldDefinitions: CustomFieldTO[];
    einstufEingebbar: boolean;
    einstufNK: number;
    einstufText: string;
    einstufZwingend: boolean;
    gentext?: string;
    zspArt: ZspArt;
}

export interface Serializable {
}

export interface StPreviewTO {
    datum: number;
    stTagkey: string;
}

export interface StTO {
    anzTage: number;
    feierSollKz: string;
    genKz: string;
    stkey: string;
    sttext: string;
    verrkey: string;
}

export interface StTagTO {
    colorBg: string;
    colorTxt: string;
    glzBeg: number;
    glzEnde: number;
    id: string;
    kernBeg: number;
    kernEnde: number;
    normalAz: number;
    normalBeg: number;
    normalEnde: number;
    sollAz: number;
    stTagText: string;
    tagBeg: number;
}

export interface StTagZuTO {
    compositeId: string;
    date: number;
    persNr: number;
    sisName: string;
    soll: number;
    stTagKey: string;
}

export interface StornoTO {
    answer: boolean;
    id: number;
    sisName: SisName;
    text: string;
    user: string;
    userText: string;
}

export interface TaskAttrTO {
    id: number;
    key: string;
    position: number;
    task: number;
    type: string;
    value: string;
}

export interface TaskTO {
    color: ColorPairTO;
    id: number;
    name: string;
    perm: PermissionTO;
    taskAttrs: TaskAttrTO[];
}

export interface TaskZuMultiTO {
    _doSplit?: boolean;
    _splitAllowed?: boolean;
    bisdat: number;
    biszeit: number;
    id: number;
    persNrs: number[];
    prio: number;
    sisName: string;
    task: number;
    text: string;
    vondat: number;
    vonzeit: number;
}

export interface TaskZuOverlapsTO {
    persurl: PersurlTO[];
    taskZu: TaskZuTO[];
}

export interface TaskZuTO {
    _doSplit?: boolean;
    _splitAllowed?: boolean;
    bisdat: number;
    biszeit: number;
    color?: ColorPairTO;
    id: number;
    persNr: number;
    prio: number;
    sisName: string;
    task: number;
    text: string;
    vondat: number;
    vonzeit: number;
}

export interface TypeGroupTO extends Serializable {
    bgColor: string;
    fgColor: string;
    icon: string;
    id: number;
    nr: number;
    text: string;
    textLong: string;
}

export interface TypeStateMemberTO {
    buart: string;
    id: number;
    nr: number;
    stuart: string;
    typeState: string;
}

export interface Typemap2umTO {
    aufBuart: string;
    aufStuart: string;
    buart: string;
    id: number;
    stuart: string;
    zgKey: string;
}

export interface VBustuBaseTO {
    altRepresentative: number;
    bewEinh: string;
    bookingTime: number;
    bookingTimespan: number;
    bookingType: string;
    einstuf: number;
    empfEinh: string;
    endDate: number;
    evaluationLink: string;
    hourCategory: string;
    id: number;
    majorGenType: string;
    majorType: string;
    mixedId: string;
    openMarking: string;
    openStorno: boolean;
    persNr: number;
    representative: number;
    sisName: SisName;
    startDate: number;
    text: string;
}

export interface ViewStoreEntryTO {
    id: number;
    key: string;
    parent: number;
    value: any;
    view: string;
}

export interface ViewStoreTO {
    id: number;
    view: string;
}

export interface VlFehlTO {
    datum: number;
    fehlerArt: FehlerArt;
    fehlerNr: number;
    fehlerText: string;
    nr: number;
    persNr: number;
    progNr: number;
}

export interface VorgztUserTO {
    className: string;
    displayName: string;
    id: string;
    longUsername: string;
    text: string;
}

/**
 * @deprecated
 */
export interface WorkTimeForkedPartVO {
    begin: number;
    datum: number;
    ende: number;
    persnr: number;
    type: Type;
}

/**
 * @deprecated
 */
export interface WorkTimeForkedVO {
    glz: WorkTimeForkedPartVO;
    kern: WorkTimeForkedPartVO;
    normal: WorkTimeForkedPartVO;
}

export interface WorkTimeModelTO {
    compositeId: string;
    coreEnd: number;
    coreStart: number;
    date: number;
    endStepSize: number;
    flexEnd: number;
    flexStart: number;
    maxDuration: number;
    normalEnd: number;
    normalStart: number;
    persNr: number;
    soll: number;
    startStepSize: number;
}

export enum AttachmentFetchMode {
    LAZY = "lazy",
    PREVIEW = "preview",
    EAGER = "eager",
}

export enum ColumnFilterMethod {
    Default = "default",
    IgnoreCase = "IgnoreCase",
    Exact = "Exact",
    ExactIgnoreCase = "ExactIgnoreCase",
    Date = "Date",
    Time = "Time",
    Duration = "Duration",
}

export enum EFileEntity {
    PERS = "pers",
    TASK = "task",
    KOST = "kost",
    AUFT = "auft",
}

export enum FehlerArt {
    UNKNOW = "UNKNOW",
    ERROR = "ERROR",
    WARNING = "WARNING",
}

export enum FreigabeType {
    Person = "Person",
    Kost = "Kost",
}

export enum JaNeinTO {
    J = "J",
    N = "N",
}

export enum ModuleType {
    WEBCLIENT = "0001",
    WEBCLIENT_CGI = "0002",
    EVOAPPS = "0003",
    EVOAPPS_HIDDEN = "9003",
    EVOAPPS_COCKPIT = "0004",
}

export enum NotiStatus {
    SENT = "S",
    QUEUED = "Q",
    FAVORITE = "F",
}

export enum PropType {
    IProperty = "i",
    UserProperty = "u",
    VirtualProperty = "v",
    Paramdiv = "p",
}

export enum SisName {
    Booking = "booking",
    Persurl = "persurl",
    PlanTempl = "PlanTempl",
    PlanEvent = "PlanEvent",
}

export enum SisType {
    GPS = "G",
    Blob = "B",
    String = "C",
    Key = "K",
    Int = "I",
    Number = "N",
    Decimal = "E",
    Float = "F",
    Date = "D",
    Time = "T",
    Duration = "H",
    Duration2 = "Z",
    DurationA = "A",
    VChar = "V",
}

export enum Type {
    NORMAL = "NORMAL",
    KERN = "KERN",
    GLZ = "GLZ",
}

export enum ZspArt {
    Betrag = "B",
    Spanne = "S",
}
